import React, { useEffect, useState } from 'react';
import { Meteor } from 'meteor/meteor';
import { strings } from '/imports/strings';
import { defer } from '/imports/utils';
import { isAndroid } from '/imports/android';
import { isIos } from '/imports/ios';

const oauth2ButtonClass = 'box-border flex h-input-lg w-full items-center justify-center rounded-input border border-primary bg-primary font-normal! text-white! no-underline hover:border-primary-2 hover:bg-primary-2 [&_img]:mr-2 [&_img]:w-6';

export const GoogleButton = () => {
  const [url, setUrl] = useState('');
  useEffect(() => {
    defer(() => {
      const params = new URLSearchParams();
      params.set('response_type', 'code');
      params.set('client_id', Meteor.settings.public.google.oauth2.clientId);
      params.set('redirect_uri', Meteor.settings.public.google.oauth2.redirectUri);
      params.set('scope', 'openid email profile');
      params.set('flowName', 'GeneralOAuthFlow');
      params.set('state', state('google'));
      setUrl(`https://accounts.google.com/o/oauth2/auth/oauthchooseaccount?${params.toString()}`);
    });
  }, []);
  return (
    <a className={oauth2ButtonClass} href={url} target="_blank" rel="noreferrer">
      <img src="/images/google_g_64.png" />{strings.UseGoogle()}
    </a>
  );
};

export const DiscordButton = () => {
  const [url, setUrl] = useState('');
  useEffect(() => {
    defer(() => {
      const params = new URLSearchParams();
      params.set('response_type', 'code');
      params.set('client_id', Meteor.settings.public.discord.oauth2.clientId);
      params.set('redirect_uri', Meteor.settings.public.discord.oauth2.redirectUri);
      params.set('scope', 'openid email identify');
      params.set('state', state('discord'));
      setUrl(`https://discord.com/oauth2/authorize?${params.toString()}`);
    });
  }, []);
  return (
    <a className={oauth2ButtonClass} href={url} target="_blank" rel="noreferrer">
      <img src="/images/discord_icon_64.png" />{strings.UseDiscord()}
    </a>
  );
};

const platform = () => {
  if (isIos()) return 'ios';
  if (isAndroid()) return 'android';
  return 'browser';
};

const state = (service: string) => {
  return window.btoa(JSON.stringify({ search: window.location.search || '', platform: platform(), service }));
};